import { FC } from "react";

const DashboardNotFound: FC = () => {
    return (
        <div className="flex items-center justify-center min-h-[80vh] px-4">
            <div className="max-w-md w-full text-center space-y-4">
                {/* Error Code */}
                <h1 className="text-8xl font-semibold text-muted-foreground/20">
                    404
                </h1>
                <h2 className="text-2xl font-semibold tracking-tight">
                    Page Not Found
                </h2>
                <p className="text-muted-foreground">
                    This page doesn't exist. Use the sidebar to navigate to another section.
                </p>
            </div>
        </div>
    );
};

export default DashboardNotFound;
